import React from 'react'
import FormComponent from '../components/formComponent';
import { renderReport } from '../components/elementList';

class UiDeviceEntity extends React.Component {

    static defaultProps = {
        finished: (deviceEntityData, deviceEntityReport) => { },
        error: (error) => { },
        services: {
            asset: {},
            customer: {}
        },
        fieldEntity: {},
        device: {},
        type: {
            name: "",
            fixedPre: '',
            fixedPost: '',
        }
    }
    constructor(props) {
        super(props);

        this.deviceService = props.services.device;
        this.customerService = props.services.customer;

        // this.stepManagerRef = createRef();

        this.state = {
            deviceEntity: null,
            finished: false,
        }
    }

    reportAllComponentData = () => {
        let { deviceEntity } = this.state;
        let { name } = this.props.type;

        if ((!deviceEntity) || (!name)) {
            return null;
        }

        let data = [
            { key: name + ' Entity Id', value: deviceEntity.id.id },
            { key: name + ' Entity Name', value: deviceEntity.name },
            { key: name + ' Entity Type', value: deviceEntity.type },
            { key: name + ' Entity Customer', value: deviceEntity.customerId.name}
        ];
        return data;
    }

    handleValidate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };

    handleSubmitError = (error) => { this.props.error(error); };


    handleEntitySubmit = (values) => {
        let { fieldEntity, device, type } = this.props;

        values.name = values.name ? values.name : type.fixedPre.toUpperCase() + device.name;
        values.type = values.type ? values.type : device.type + type.fixedPost.toLowerCase();

        return this.deviceService.addDeviceEntity(values, device.id.id).then((response) => {
            let deviceEntity = response;
            deviceEntity.customerId.name = fieldEntity.name;
            return this.deviceService.setRelationDeviceFromAsset(deviceEntity.id.id, fieldEntity.entity.id.id).then(
                () => {
                    return this.customerService.assignEntityToCustomer(deviceEntity.id.id, fieldEntity.id).then(
                        () => {
                            this.setState(
                                { deviceEntity: deviceEntity, finished: true },
                                () => {this.props.finished(deviceEntity, this.reportAllComponentData());}
                            );
                        }).catch(this.handleSubmitError);
                }).catch(this.handleSubmitError);
        }).catch(this.handleSubmitError);
    };

    renderEntityForm = () => {
        let { fieldEntity, device, type } = this.props;

        return (
            <div>
                <FormComponent
                    initialValues={{
                        name: `${type.fixedPre}${device.name}`,
                        type: `${device.type}${type.fixedPost}`,
                        field: fieldEntity.entity.name,
                        customer: fieldEntity.name
                    }}
                    validateFunc={this.handleValidate}
                    submitFunc={this.handleEntitySubmit}
                    inputs={[
                        { key: 'name', type: 'text', inputType: 'input', placeholder: 'Name', label: 'Name', disabled: true },
                        { key: 'type', type: 'text', inputType: 'input', placeholder: 'Type', label: 'Type', disabled: true },
                        { key: 'field', type: 'text', inputType: 'input', placeholder: type.name.toLowerCase(), label: `${type.name} Field`, disabled: true },
                        { key: 'customer', type: 'text', inputType: 'input', placeholder: 'Customer', label: 'Customer', disabled: true }
                    ]}
                />
            </div>
        );
    };
    render() {
        let { finished } = this.state;
        if (finished) {
            return renderReport(this.reportAllComponentData());
        }
        else {
            return this.renderEntityForm();
        }
    }
}


export default UiDeviceEntity;